import { fetchWorkplaces, storeWorkplaceClass } from '@/service/shift/workplaces';
import { getChildClassCategoryNames } from '@/service/shift/childClasses';
import { getChildGroupCategoryNames, updateChildGroupWorkplace } from '@/service/shift/childGroups';
import { storeClassGroupWorkplace, updateClassGroupWorkplace } from '@/service/shift/classGroups';
import cloneDeep from 'lodash.clonedeep';

function settingWorkplacesCtrl($scope, $state, serverService, $modal, $window, $cookies, notify) {
  $scope.isShowUnusedMode = false;
  $scope.classGroupName = '';
  $scope.classGroup = {
    name: null,
  };

  $scope.workplaces = {
    classes: [],
    employeeGroups: [],
    classGroups: [],
    meta: [],
  };

  //  複数同時編集できないので編集可能な物のIDを保持
  $scope.isWorkplaceEditModeClassId = '';
  $scope.isWorkplaceEditMode = {
    classId: '',
    groupId: '',
    classGroupId: '',
  };

  //   編集に使用する一時的なクラスのデータ
  $scope.tmpEditClass = {};
  //   編集に使用する一時的な園児グループのデータ
  $scope.tmpEditChildGroup = {};
  //   編集に使用する一時的なクラスグループのデータ
  $scope.tmpEditClassGroup = {};

  $scope.classGroupEditMode = false;

  /**
   * キャンセルボタンが押された時
   */
  $scope.closeWorkplaceChildClassEditMode = () => {
    $scope.isWorkplaceEditModeClassId = '';
    $scope.tmpEditClass = {};
    $scope.$digest();
  };

  /**
   * クラスの保存ボタンが押された時
   */
  $scope.saveWorkplaceClass = async (targetClassId) => {
    if (!targetClassId) {
      $scope.closeWorkplaceChildClassEditMode();
      return;
    } else {
      const editTargetClassIndex = $scope.workplaces.classes.findIndex(
        (workplaceClass) => workplaceClass.classId === targetClassId
      );
      const { classId, colorName, disabled, version } = $scope.tmpEditClass;
      const payload = { colorName, disabled, version };
      const response = await storeWorkplaceClass(classId, payload);
      $scope.workplaces.classes[editTargetClassIndex] = response;
      $scope.closeWorkplaceChildClassEditMode();
    }
  };

  /**
   * 編集ボタンが押され編集モードへ切り替え
   */
  $scope.switchToEmployeeGroupSettingEditMode = (group) => {
    $scope.isWorkplaceEditMode.groupId = group.groupId;
    $scope.tmpEditChildGroup = cloneDeep(group);
  };

  /**
   * 編集ボタンが押され編集モードへ切り替え
   */
  $scope.switchToClassSettingEditMode = (classObj) => {
    $scope.isWorkplaceEditModeClassId = cloneDeep(classObj.classId);
    // 編集用のデータをコピー
    $scope.tmpEditClass = cloneDeep(classObj);
  };

  /**
   * カラーパレットのプレビュー表示
   * @return {object} colorPalette--${color}
   */
  $scope.colorClasses = (color) => {
    let colorClasses = {};
    colorClasses[`colorPalette--${color}`] = true;
    return colorClasses;
  };

  /**
   * クラスを配列にセット
   * @param {*} classes
   */
  const setWorkplaceClasses = (classes) => {
    $scope.workplaces.classes = classes;
  };

  /**
   * ==========================================
   * 園児グループ
   * ==========================================
   */

  /**
   * キャンセルボタンが押された時
   */
  $scope.closeWorkplaceEmployeeGroupEditMode = () => {
    $scope.isWorkplaceEditMode.groupId = '';
    $scope.tmpEditChildGroup = {};
    $scope.$digest();
  };

  /**
   * 保存ボタンが押された時
   */
  $scope.saveWorkplaceChildGroup = async (employeeGroupId) => {
    const editTargetChildGroupIndex = $scope.workplaces.employeeGroups.findIndex(
      (employeeGroup) => employeeGroup.groupId === employeeGroupId
    );

    const { groupId, colorName, disabled, version } = $scope.tmpEditChildGroup;
    const payload = { colorName, disabled, version };
    const response = await updateChildGroupWorkplace(groupId, payload);
    if (!response) return;

    $scope.workplaces.employeeGroups[editTargetChildGroupIndex] = response;
    $scope.closeWorkplaceEmployeeGroupEditMode();
  };

  /**
   * クラスを配列にセット
   * @param {*} employeeGroups
   */
  const setWorkplaceEmployeeGroups = (employeeGroups) => {
    $scope.workplaces.employeeGroups = employeeGroups;
  };

  /**
   * ==========================================
   * クラスグループ
   * ==========================================
   */

  const setClassGroups = (classGroups) => {
    $scope.workplaces.classGroups = classGroups;
  };

  $scope.addClassGroup = (classGroup) => {
    $scope.workplaces.classGroups.push(classGroup);
    $scope.clonedWorkplaces.classGroups.push(classGroup);
  };

  const createModalOptions = async () => {
    const fetchedChildGroups = $scope.workplaces.employeeGroups;
    const fetchedChildClasses = $scope.workplaces.classes;

    const groupCategoryNames = getChildGroupCategoryNames(fetchedChildGroups);
    const classCategoryNames = getChildClassCategoryNames(fetchedChildClasses);

    /**
     * 園のクラスグループ一覧
     * グルーピングしてreturn
     * ```js
     *  {
     *   groupCategoryName: '園児グループ1',
     *   groups: [
     *     { id: '31', employeeGroupName: '1丁目の帰宅組' },
     *     { id: '32', employeeGroupName: '2丁目の帰宅組' },
     *   ],
     * }
     * ```
     */
    const childGroups = groupCategoryNames.map((groupCategoryName) => {
      const filteredChildGroups = fetchedChildGroups.filter(
        (fetchedChildGroup) => groupCategoryName === fetchedChildGroup.groupCategoryName
      );
      return { groupCategoryName, groups: filteredChildGroups };
    });

    /**
     * 園のクラスグループ一覧
     * グルーピングしてreturn
     * ```js
     * {
     *   classCategoryName: '小1全体',
     *   classes: [{ id: '31', className: '小1' }],
     * },
     * {
     *   classCategoryName: '小2全体',
     *   classes: [{ id: '32', className: '小2' }],
     * },
     * ```
     */
    const classes = classCategoryNames.map((classCategoryName) => {
      const filteredChildClass = fetchedChildClasses.filter(
        (fetchedChildClass) => classCategoryName === fetchedChildClass.classCategoryName
      );
      return {
        classCategoryName,
        classes: filteredChildClass,
      };
    });

    $scope.childGroupsModalOptions = childGroups;
    $scope.classesGroupByAgeOptions = classes;
  };

  const openSettingWorkplaceClassGroupModal = () => {
    $scope.workplaceModal = $modal.open({
      templateUrl: '/manage/src/view/service/shift_v2/setting_workplace_class_group_modal.html',
      windowClass: 'anglrC-modal',
      controller: 'settingCreateWorkplaceModalCtrl',
      scope: $scope,
      size: 'sm',
      backdrop: 'static',
      windowClass: 'anglrC-modal',
    });
  };

  const turnOnClassGroupEditMode = () => {
    $scope.classGroupEditMode = true;
  };
  const turnOffClassGroupEditMode = () => {
    $scope.classGroupEditMode = false;
  };

  /**
   * モーダル用のクラスの選択肢一覧の作成
   * @param {*} classGroup
   * @param {*} childClasses
   */
  const createChildClassesModalOptions = (classGroup, childClasses) => {
    if (!childClasses) return [];
    return childClasses.map((childClass) => {
      const { classCategoryName, classes } = childClass;
      const formattedChildClasses = cloneDeep(classes).map((classObj) => {
        const isSelected = classGroup.classes.some((selectedClass) => selectedClass.classId === classObj.classId);
        if (classObj.disabled) {
          classObj.className = classObj.className + '(不使用)';
        }
        return { ...classObj, selected: isSelected };
      });
      return { classCategoryName, classes: formattedChildClasses };
    });
  };

  /**
   * モーダル用の園児グループの選択肢一覧の作成
   * @param {*} classGroup
   * @param {*} childGroups
   */
  const createChildGroupModalOptions = (classGroup, childGroups) => {
    if (!childGroups) return [];
    return childGroups.map((childGroup) => {
      const { groupCategoryName, groups } = childGroup;
      const formattedChildGroups = cloneDeep(groups).map((group) => {
        const isSelected = classGroup.groups.some((selectedGroup) => selectedGroup.groupId === group.groupId);
        if (group.disabled) {
          group.className = group.className + '(不使用)';
        }
        return { ...group, selected: isSelected };
      });
      return { groupCategoryName, groups: formattedChildGroups };
    });
  };

  const setModalOptions = (classGroup) => {
    $scope.childClassesModalOptions = createChildClassesModalOptions(classGroup, $scope.classesGroupByAgeOptions);
    $scope.childGroupsModalOptions = createChildGroupModalOptions(classGroup, $scope.childGroupsModalOptions);
  };

  $scope.openClassGroupEditModal = (classGroup) => {
    setModalOptions(classGroup);

    $scope.tmpEditClassGroup = cloneDeep(classGroup);
    turnOnClassGroupEditMode();

    openSettingWorkplaceClassGroupModal();
  };

  $scope.openClassGroupCreateModal = () => {
    const classGroup = {
      classGroupId: '',
      classGroupName: '',
      classes: [],
      colorName: 'paleBlue',
      disabled: false,
      groups: [],
      version: 0,
      workplaceId: '',
    };
    setModalOptions(classGroup);
    $scope.tmpEditClassGroup = classGroup;
    turnOffClassGroupEditMode();
    openSettingWorkplaceClassGroupModal();
  };

  const initial = async () => {
    const response = await fetchWorkplaces();
    const { classGroupWorkplaces, classWorkplaces, groupWorkplaces } = response;

    setWorkplaceClasses(classWorkplaces);
    setWorkplaceEmployeeGroups(groupWorkplaces);
    setClassGroups(classGroupWorkplaces);
    createModalOptions();
    $scope.$digest();
  };

  initial();
}

function settingCreateWorkplaceModalCtrl($scope) {
  /**
   * バリデーション条件
   * クラスグループ名が空
   * クラスグループ名が重複している
   * クラス・園児グループが合計で3つ以上選択されていない
   */
  $scope.isSaveButtonDisabled = () => {
    const isClassGroupNameEmpty = !$scope.tmpEditClassGroup.classGroupName;
    const isCreateClassGroupFormInvalid = $scope.createClassGroupForm.classGroupName.$invalid;
    const isClassGroupNameDuplicate =
      $scope.createClassGroupForm.classGroupName.$error && $scope.createClassGroupForm.classGroupName.$error.duplicate;
    let childClassesSelectedCount = 0;
    let childGroupsSelectedCount = 0;
    $scope.childClassesModalOptions.forEach((childClassesModalOption) => {
      const count = childClassesModalOption.classes.filter((childClass) => childClass.selected).length;
      childClassesSelectedCount += count;
    });
    $scope.childGroupsModalOptions.forEach((childGroupsModalOption) => {
      const count = childGroupsModalOption.groups.filter((childGroup) => childGroup.selected).length;
      childGroupsSelectedCount += count;
    });
    const isSelectedThreeOrMore = childClassesSelectedCount + childGroupsSelectedCount >= 2;
    return (
      isClassGroupNameEmpty || isCreateClassGroupFormInvalid || !isSelectedThreeOrMore || isClassGroupNameDuplicate
    );
  };
  /**
   * クラスグループをDBに保存
   */
  const storeClassGroup = async () => {
    // const response = await classGroupsRepository.create({ params }).catch((err) => {
    // 	showErrorNotification(err, { notify, state });
    // return {data: {}}
    // });
    const response = {
      data: {
        classGroupId: `${$scope.workplaces.classGroups.length + 1}`,
        classGroupName: $scope.classGroup.name,
        selected: false,
        $$hashKey: 'object:240',
      },
    };
    return response.data;
  };
  /**
   * クラスグループの作成
   */
  const createClassGroup = async () => {
    const response = await storeClassGroup();
    if (response) $scope.addClassGroup(response);
  };

  /**
   * モーダルの初期化
   */
  const initializeModal = () => {
    $scope.childClassesModalOptions = [];
    $scope.childGroupsModalOptions = [];
    $scope.tmpEditClassGroup = {};
  };

  //   $scope.onClickCheckbox = () => {
  //     //   選択されているチェックボックの数を取得
  //     const selectedChildClassesIds = $scope.childClassesModalOptions.flatMap((classesGroupByAgeModalOption) =>
  //       classesGroupByAgeModalOption.classes.filter((classObj) => classObj.selected).map((classObj) => classObj.classId)
  //     );
  //     //   選択されている園児グループのIDの配列を作成
  //     const selectedChildGroupIds = $scope.childGroupsModalOptions.flatMap((employeeGroupModalOption) =>
  //       employeeGroupModalOption.groups.filter((group) => group.selected).map((group) => group.groupId)
  //     );
  //     //   選択されているチェックボックの数が2つ以上なら保存可能
  //     if ([...selectedChildClassesIds, ...selectedChildGroupIds].length < 2 || !$scope.tmpEditClassGroup.classGroupName) {
  //       $scope.createClassGroupForm.classGroupName.$invalid = true;
  //     }
  //   };
  /**
   * モーダルを閉じる
   */
  $scope.closeModal = () => {
    initializeModal();
    $scope.workplaceModal.close();
  };
  /**
   * モーダルの保存ボタンの処理
   */
  $scope.saveWorkplacesModal = async () => {
    const { classGroupId, disabled, classGroupName, colorName, version } = $scope.tmpEditClassGroup;
    //   選択されているクラスのIDの配列を作成
    const selectedChildClassesIds = $scope.childClassesModalOptions.flatMap((classesGroupByAgeModalOption) =>
      classesGroupByAgeModalOption.classes.filter((classObj) => classObj.selected).map((classObj) => classObj.classId)
    );
    //   選択されている園児グループのIDの配列を作成
    const selectedChildGroupIds = $scope.childGroupsModalOptions.flatMap((employeeGroupModalOption) =>
      employeeGroupModalOption.groups.filter((group) => group.selected).map((group) => group.groupId)
    );

    const payload = {
      classGroupName,
      classIds: selectedChildClassesIds,
      groupIds: selectedChildGroupIds,
      colorName,
      disabled,
      version,
    };

    if (classGroupId) {
      const createdClassGroupWorkplace = await updateClassGroupWorkplace(classGroupId, payload);
      if (createdClassGroupWorkplace.status === 200) {
        // 更新
        const targetIdx = $scope.workplaces.classGroups.findIndex(
          (classGroup) => classGroup.classGroupId === $scope.tmpEditClassGroup.classGroupId
        );
        $scope.workplaces.classGroups[targetIdx] = createdClassGroupWorkplace.data;
      }
    } else {
      const updatedClassGroupWorkplace = await storeClassGroupWorkplace(payload);
      if (updatedClassGroupWorkplace.status === 200) {
        // 新規作成
        $scope.workplaces.classGroups.push(updatedClassGroupWorkplace.data);
      }
    }

    $scope.closeModal();
  };

  $scope.classGroupDuplicateValidationRule = {
    message: 'クラスグループ名が重複しています',
    items: $scope.workplaces.classGroups
      .flatMap((classGroup) => classGroup.classGroupName)
      .filter((classGroupName) => classGroupName !== $scope.tmpEditClassGroup.classGroupName),
    value: '',
  };

  // TODO: フォームバリデーションの問題解決しない場合に重複チェックの対応を行う
  $scope.onInputClassGroup = (classGroupName) => {
    $scope.classGroupDuplicateValidationRule.value = classGroupName;
    $scope.$apply();
  };
}

angular
  .module('inspinia')
  .controller('settingWorkplacesCtrl', settingWorkplacesCtrl)
  .controller('settingCreateWorkplaceModalCtrl', settingCreateWorkplaceModalCtrl);
